import { useSelector } from 'react-redux';

import { Helpers } from '../core/src/helpers';
import { isDealActive } from '../product/components/deals';
import useSiteConfig from './useSiteConfig';

//GFE countdown component uses a different format than the deals api
const nomralizeFormat = format => {
    if (!format) return '';
    return format.replace(/(\w)\?/g, '?$1');
};

/**
 * @typedef {Object} Deals
 */

/**
 * Returns any active deals assocciated with the provided products and returns the deal that expires the soonest
 * @param {*} poducts
 * @param {*} deals
 */
export const selectDeals = (poducts, deals, dateFormat) => {
    let expiresSoon;
    let minDate;
    const activeDeals = (poducts || []).reduce((r, prd) => {
        try {
            const catId = Helpers.getCatEntryId(prd);
            const deal = deals[catId] || {};
            const { activeDeal } = deal;
            if (!isDealActive(deal)) {
                return r;
            }
            const { endDate } = activeDeal;
            //find the deal that expires the soonest
            if (!minDate || new Date(endDate) < minDate) {
                minDate = new Date(endDate);
                expiresSoon = activeDeal;
            }
            r[catId] = activeDeal;
        } catch (e) {
            console.error('Error in useDeals', e);
        }

        return r;
    }, {});
    return { activeDeals, expiresSoon, dateFormat, gfeDateFormat: nomralizeFormat(dateFormat) };
};

/**
 * Returns redux connected page functions
 * @name useDeals
 * @returns {Deals}
 */
export default function useDeals(products) {
    const deals = useSelector(state => state.deals);
    const { intraDayDeal } = useSiteConfig();
    const { dateFormat } = intraDayDeal || {};
    return selectDeals(products, deals, dateFormat);
}
